import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import Header from './Header'
import {
  getNavLinksForIdentityAsArray,
  isAdmin,
  isMultiAdmin,
  isOrganizationHasReactions,
  isSuperAdmin,
  isSuperOrMultiAdmin,
  isUser,
} from 'store/entities/identity/selectors'

import {
  isMicroActionsAvailableForOrganization,
  isReviewsAvailableForOrganization,
} from 'store/entities/organizations/selectors'

import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'

const mapStateToProps = createStructuredSelector({
  showReactions: isOrganizationHasReactions,
  navLinks: getNavLinksForIdentityAsArray,
  isReviewsAvailable: isReviewsAvailableForOrganization,
  isMicroActionsAvailable: isMicroActionsAvailableForOrganization,
  isSuperAdmin,
  isAdmin,
  isMultiAdmin,
  isSuperOrMultiAdmin,
  isUser,
  windowWidth: getUIWindowSizesWidth,
})

export default withRouter(connect(mapStateToProps)(Header))
